import React from 'react';

const Level1Headers: React.FC = () => {
  return (
    <div className='view-history-head-frame'>
      <div className='view-history-head-frame-cell'>
        <div className='view-history-head-frame-cell-cont'>
          <div className='view-history-head-frame-cell-cont-text'>
            Searched Value
          </div>
        </div>
      </div>
      <div className='view-history-head-frame-cell'>
        <div className='view-history-head-frame-cell-cont'>
          <div className='view-history-head-frame-cell-cont-text'>
            Total Results
          </div>
        </div>
      </div>
      <div className='view-history-head-frame-cell'>
        <div className='view-history-head-frame-cell-cont'>
          <div className='view-history-head-frame-cell-cont-text'>
            New Results
          </div>
        </div>
      </div>
      <div className='view-history-head-frame-cell-emptys'>
        <div className='view-history-head-frame-cell-cont'>
          <div className='view-history-head-frame-cell-cont-text'>Actions</div>
        </div>
      </div>
    </div>
  );
};

export default Level1Headers;
